import { useGetAgreement } from '../../shared/queries/useGetAgreement';
import DOMPurify from 'dompurify';
import styles from './AgreementModal.module.scss';
import { AsyncDataHandler, Modal } from '@ds';

interface AgreementModalProps {
  agreementId?: number;
  visible: boolean;
  onModalClosed: () => void;
}

const AgreementModal = ({ agreementId = 0, visible, onModalClosed }: AgreementModalProps) => {
  const { data: agreement, isLoading, error } = useGetAgreement(agreementId);
  const title = agreement?.applicationLicenseName || '';

  return (
    <Modal
      visible={visible}
      onModalClosed={onModalClosed}
      className={styles['agreement-modal']}
      title={title}
      modalClassName={styles['modal']}
    >
      <AsyncDataHandler isLoading={isLoading} error={error}>
        {agreement && (
          <div
            className={styles.content}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(agreement.licenseContent, { ADD_ATTR: ['target'] }) }}
          />
        )}
      </AsyncDataHandler>
    </Modal>
  );
};

export default AgreementModal;
